import React from 'react';

import { Container, Label, InputWrapper, ErrorContainer } from './styles';

const PaymentIframeInputUi = ({ iframeTargetId, label, error, isEmpty, isFocused }) => (
    <Container active={isFocused || !isEmpty}>
        <Label active={isFocused || !isEmpty}>{label}</Label>
        <InputWrapper id={iframeTargetId} active={isFocused || !isEmpty} />
        {error && <ErrorContainer>{error}</ErrorContainer>}
    </Container>
);

export default PaymentIframeInputUi;
